import { apiClient } from '../../../api/httpClient';

export const getAuthStatus = () => (
  apiClient.get('/auth/status', { withCredentials: true })
);

export const getLoginUrl = () => (
  `${process.env.VUE_APP_API_ENDPOINT}/auth/login`
);

export const logout = () => (
  apiClient.get('/auth/logout', { withCredentials: true })
);

